import { superAppApi } from '../../../core';
import {
  ICreateSubscriptionPromoCodePayload,
  ISubscriptionPromoCode,
  IUpdateSubscriptionPromoCodePayload,
} from '../types/promo-code.types';

export const promoCodeApi = superAppApi.injectEndpoints({
  endpoints: (builder) => ({
    getPromoCodes: builder.query<ISubscriptionPromoCode[], void>({
      query: () => ({
        url: '/payments/promo-codes',
        method: 'GET',
      }),
      providesTags: ['PromoCodes'],
      transformResponse: (response: { data: ISubscriptionPromoCode[] }) =>
        response.data,
    }),
    createPromoCode: builder.mutation<
      ISubscriptionPromoCode,
      ICreateSubscriptionPromoCodePayload
    >({
      query: (body) => ({
        url: '/payments/promo-codes',
        method: 'POST',
        body: {
          data: {
            type: 'SubscriptionPromoCode',
            attributes: body,
          },
        },
      }),
      invalidatesTags: ['PromoCodes'],
      transformResponse: (response: { data: ISubscriptionPromoCode }) =>
        response.data,
    }),
    updatePromoCode: builder.mutation<
      ISubscriptionPromoCode,
      IUpdateSubscriptionPromoCodePayload
    >({
      query: ({ id, ...body }) => ({
        url: `/payments/promo-codes/${id}`,
        method: 'PATCH',
        body: {
          data: {
            type: 'SubscriptionPromoCode',
            attributes: body,
          },
        },
      }),
      invalidatesTags: ['PromoCodes'],
      transformResponse: (response: { data: ISubscriptionPromoCode }) =>
        response.data,
    }),
  }),
});

export const {
  useGetPromoCodesQuery,
  useCreatePromoCodeMutation,
  useUpdatePromoCodeMutation,
} = promoCodeApi;
